import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//登陆和主页面
import Home from 'views/home'
import Login from 'views/Login'
import Login2 from 'views/Login2'
import JwtLogin from 'views/JwtLogin'

// 无角色页面
import NoPermission from 'views/noPermission'

import Dashboard from 'views/dashboard/dashboard'
// 人员中心
import SalespersonLibrary from 'views/personnelCenter/salespersonLibrary'
import SalespersonDetail from 'views/personnelCenter/salespersonDetail'
import BaseCenter from 'views/personnelCenter/baseCenter'
import BlackList from 'views/personnelCenter/blackList'
import GreyList from 'views/personnelCenter/greyList'
import ImportScore from 'views/personnelCenter/importScore'
import salespersonDataShow from 'views/personnelCenter/salespersonDataShow'
import test from 'views/personnelCenter/test123'
import Questionnaire from 'views/personnelCenter/questionnaire'
import dummyPhoneRecode from 'views/personnelCenter/dummyPhoneRecode'
import projectConfig from 'views/personnelCenter/projectConfig'
import projectSupplierRecord from 'views/personnelCenter/projectSupplierRecord'
import projectCategory from 'views/personnelCenter/projectCategory'
import customerConfig from 'views/personnelCenter/customerConfig'
import virtualProject from 'views/personnelCenter/virtualProject'
import supervise from 'views/personnelCenter/supervise'
import QHRPersonnel from 'views/personnelCenter/QHRPersonnel'
import customerProject from 'views/personnelCenter/CustomerProject'
import FlexibleSigningRecord from 'views/personnelCenter/FlexibleSigningRecord'



// 标签体系
import LabelManagement from 'views/labelSystem/labelManagement'
import ProjLabelConfig from 'views/labelSystem/projLabelConfig'
// 筛选项配置
import FilterSetting from 'views/filterSetting/filterSetting'
//权限管理 角色管理
import limitManager from 'views/limit/limitManager'
import userManager from 'views/limit/userManager'

// icon
import DashboardIcon from 'common/images/1Dashboard.png'
import DashboardIconActive from 'common/images/1Dashboard2.png'
import renyuan from 'common/images/2renyuan.png'
import biaoqian from 'common/images/7biaoqian.png'
import shaixuan from 'common/images/9shaixuan.png'
import shaixuanActive from 'common/images/9shaixuan2.png'
//权限管理icon
import quanxian from 'common/images/8quanxian.png'

//评估体系
import pinggu from 'common/images/6pinggu.png'
import SystemConfig from 'views/Assessment/SystemConfig'
import EvaluationDetail from 'views/Assessment/EvaluationDetail'
import LookHistory from 'views/Assessment/LookHistory'
import LookHistoryTwo from 'views/Assessment/LookHistoryTwo'

// import PDF from 'views/Assessment/cPDF'

// 工作广场
import square from 'common/images/3gongchang.png'
import ManagementApply from 'views/workSquare/managementApply'
import PostJob from 'views/workSquare/postJob/postJob'
import supplierPermute from 'views/workSquare/supplierPermute'
import PublishTaskConfiguration from 'views/workSquare/PublishTaskConfiguration'

//配置管理
import MappingMead from 'views/configCanage/mappingMead/MappingMead'
import Tomd from 'views/configCanage/tomd/Tomd'
import Whitelist from 'views/configCanage/whitelist/Whitelist'
import AgreeProject from 'views/configCanage/agreeProject/AgreeProject'
import MapperProject from 'views/configCanage/mapper/MapperProject'

//任务中心
import PostTask from 'views/taskCenter/postTask/postTask'
import TaskAudit from 'views/taskCenter/taskAudit/taskAudit'
import renwuzhongxin from 'common/images/icon_taskCenter.png'

// 友情链接/工作快讯
import WorkNews from 'views/friendLink/workNews'
import friendLink from 'common/images/17youqinglianjie.png'

let routes = [
  {
    path: '/',
    component: Home,
    hidden: true,
    children: [
      { path: '/noPermission', component: NoPermission, name: '无权限页面', webId: null, hidden: true },
    ]
  },
  {
    path: '/',
    component: Home,
    name: 'Dashboard',
    redirect: '/dashboard',
    leaf: true,
    icon: DashboardIcon,
    iconActive: DashboardIconActive,
    children: [
      { path: '/dashboard', component: Dashboard, name: 'Dashboard', webId: 25, hidden: false },
    ]
  },
  {
    path: '/',
    component: Login,
    name: '登陆',
    leaf: true,
    hidden: true,
    children: [
      { path: '/login', component: Login, name: '登陆', webId: null, hidden: true },
    ]
  },
  {
    path: '/',
    component: Login2,
    name: '登陆',
    leaf: true,
    hidden: true,
    children: [
      { path: '/loginPG', component: Login2, name: '登陆', webId: null, hidden: true },
    ]
  },
  {
    path: '/',
    component: JwtLogin,
    name: '登陆',
    leaf: true,
    hidden: true,
    children: [
      { path: '/jwtLogin', component: JwtLogin, name: '登陆', webId: null, hidden: true },
    ]
  },
  {
    path: '/',
    component: Home,
    name: '人员中心',
    hidden: false,
    icon: renyuan,
    children: [
      { path: '/salespersonLibrary', component: SalespersonLibrary, name: '促销员库', webId: 1, hidden: false },
      { path: '/salespersonDetail', component: SalespersonDetail, name: '促销员详情', hidden: true, webId: null },
      { path: '/baseCenter', component: BaseCenter, name: '基础中心', webId: 2, hidden: false },
      { path: '/qhrPersonnel', component: QHRPersonnel, name: 'QHR人员库', webId: 44, hidden: false },
      { path: '/blackList', component: BlackList, name: '黑名单', webId: 17, hidden: false },
      { path: '/greyList', component: GreyList, name: '灰名单', webId: 47, hidden: false },
      { path: '/importScore', component: ImportScore, name: '导入评分数据', webId: 18, hidden: false },
      { path: '/salespersonDataShow', component: salespersonDataShow, name: '促销员数据', webId: 27, hidden: false },//宝洁专用页面
      { path: '/notFound404', component: test, name: '', webId: 999, hidden: true },
      { path: '/dummyPhoneRecode', component: dummyPhoneRecode, name: '拨号记录', webId: 34, hidden: false },
      { path: '/supervise', component: supervise, name: '兼职签约查询', webId: 42, hidden: false },
      { path: '/flexibleSigningRecord', component: FlexibleSigningRecord, name: '灵工签约记录', webId: 52, hidden: false },
    ]
  },
  {
    path: '/',
    component: Home,
    name: '工作广场',
    hidden: false,
    icon: square,
    children: [
      { path: '/postJob', component: PostJob, name: '岗位发布', webId: 5, hidden: false },
      { path: '/managementApply', component: ManagementApply, name: '岗位管理', webId: 6, hidden: false },
      { path: '/publishTaskConfiguration', component:PublishTaskConfiguration, name: '任务字段配置', webId: 43, hidden: false },
      { path: '/projectConfig', component: projectConfig, name: '项目配置', webId: 35, hidden: false },
      { path: '/projectSupplierRecord', component: projectSupplierRecord, name: '项目灵工记录', webId: 55, hidden: false },
      { path: '/projectCategory', component: projectCategory, name: '自定义项目类型', webId: 45, hidden: false },
      { path: '/customerConfig', component: customerConfig, name: '客户配置', webId: 39, hidden: false },
      { path: '/supplierPermute', component: supplierPermute, name: '供应商置换', webId: 40, hidden: false },
      { path: '/virtualProject', component: virtualProject, name: '虚拟项目维护', webId: 41, hidden: false },
      { path: '/customerProject', component: customerProject, name: '客户项目维护', webId: 46, hidden: false },
    ]
  },
  {
    path: '/',
    component: Home,
    name: '配置管理',//webId 48
    hidden: false,
    icon: shaixuan,
    children: [
      { path: '/mapping', component: MappingMead, name: '美赞人员映射', webId: 49, hidden: false },
      { path: '/tomd', component: Tomd, name: 'TOMD', webId: 50, hidden: false },
      { path: '/whitelist', component: Whitelist, name: '长促白名单', webId: 51, hidden: false },
      { path: '/agreeProject', component: AgreeProject, name: '协议授权配置', webId: 53, hidden: false },
      { path: '/mapperProject', component: MapperProject, name: '灵工项目映射', webId: 54, hidden: false },
    ]
  },
  // {
  //   path: '/',
  //   component:Home,
  //   name: '米咖调研',
  //   hidden: false,
  //   icon: square,
  //   children: [
  //     { path: '/questionnaire', component: Questionnaire, name: '快决策问卷', webId: 33, hidden: false}
  //   ]
  // },
  // {
  //   path: '/',
  //   component:Home,
  //   name: '任务中心',//TaskCenter
  //   hidden: false,
  //   icon: renwuzhongxin,
  //   children: [
  //     { path: '/postTask', component: PostTask, name: '任务发布', webId: 29, hidden: false },
  //     { path: '/taskAudit', component: TaskAudit, name: '任务审核', webId: 30, hidden: false },
  //   ]
  // },
  {
    path: '/',
    component: Home,
    name: '标签体系',
    icon: biaoqian,
    hidden: false,
    children: [
      { path: '/labelManagement', component: LabelManagement, name: '标签管理', webId: 8, hidden: false },
      { path: '/projLabelConfig', component: ProjLabelConfig, name: '项目标签配置', webId: 10, hidden: false },
    ]
  },
  //权限管理
  {
    path: '/',
    component: Home,
    name: '权限管理',
    icon: quanxian,
    hidden: false,
    children: [
      //角色管理
      { path: '/limitManager', component: limitManager, name: '角色管理', webId: 13, hidden: false },
      { path: '/userManager', component: userManager, name: '用户管理', webId: 14, hidden: false }
    ]
  },
  {
    path: '/',
    component: Home,
    name: '评估体系',
    icon: pinggu,
    hidden: false,
    children: [
      { path: '/SystemConfig', component: SystemConfig, name: '体系配置', webId: 20, hidden: false },
      { path: '/EvaluationDetail', component: EvaluationDetail, name: '评估明细查询', webId: 21, hidden: false },
      { path: '/LookHistory', component: LookHistory, name: '配置历史查询', hidden: true, webId: null },
      { path: '/LookHistoryTwo', component: LookHistoryTwo, name: '配置历史查询2', hidden: true, webId: null },
      // {path : '/PDF', component : PDF,  name : 'PDFDEMO',webId: 21, hidden: false},
    ]
  },
  {
    path: '/',
    component: Home,
    leaf: true,
    icon: shaixuan,
    name: '筛选项配置',
    hidden: false,
    iconActive: shaixuanActive,
    children: [
      { path: '/filterSetting', component: FilterSetting, name: '筛选项配置', webId: 24, hidden: false },
    ]
  },
  {
    path: '/',
    component: Home,
    name: '友情链接',
    icon: friendLink,
    hidden: false,
    children: [
      { path: '/workNews', component: WorkNews, name: '工作快讯', webId: 37, hidden: false, }
    ]
  }

]
export default new Router({
  linkActiveClass: 'active',
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js